import { Button, mergeClasses, tokens } from '@fluentui/react-components';
import FirstRunIcon from '@office-start/first-run-icon';
import React from 'react';
import { FirstRunImage } from './FirstRunImage';
import { useFirstRunPromotionStyles } from './FirstRunPromotion.styles';
import { applyTextHighlights } from './helpers/applyTextHighlights';
export var FirstRunPromotion = function (_a) {
    var slideGroup = _a.slideGroup, active = _a.active, activeSlideIdx = _a.activeSlideIdx, callbacks = _a.callbacks, context = _a.context, themeMode = _a.themeMode;
    var styles = useFirstRunPromotionStyles();
    var activeSlide = slideGroup[activeSlideIdx];
    var containerStyle = React.useMemo(function () {
        return mergeClasses(styles.container, active && styles.containerActive);
    }, [styles.container, styles.containerActive, active]);
    var promotionElement = React.useMemo(function () {
        return (React.createElement("div", { "data-testid": "first-run-promotion", className: containerStyle },
            React.createElement("div", { className: styles.wrapper },
                React.createElement("div", { className: styles.contentLeft },
                    React.createElement(FirstRunImage, { imgConfig: activeSlide.image, className: styles.image, themeMode: themeMode, context: context })),
                React.createElement("div", { className: styles.contentRight },
                    React.createElement("div", { className: styles.textWrapper },
                        React.createElement("div", { className: styles.headlineText },
                            React.createElement("h2", null, applyTextHighlights(activeSlide.headline))),
                        React.createElement("div", { className: styles.titleText },
                            React.createElement("h3", null, applyTextHighlights(activeSlide.title))),
                        React.createElement("ul", { className: styles.highlightText }, activeSlide.highlights.map(function (highlight, idx) { return (React.createElement("li", { key: idx },
                            React.createElement(FirstRunIcon, { name: highlight.icon, color: tokens.colorBrandForeground1 }),
                            React.createElement("span", null, highlight.text))); }))),
                    React.createElement("div", { className: styles.buttonContainer }, activeSlide.button && (React.createElement(Button, { appearance: "primary", onClick: function () {
                            return callbacks.handleUpsellButtonClick(activeSlide);
                        } }, activeSlide.button.text)))))));
    }, [activeSlide, containerStyle, styles, callbacks, context, themeMode]);
    return promotionElement;
};
//# sourceMappingURL=FirstRunPromotion.js.map